import { render, staticRenderFns } from "./Experiments.vue?vue&type=template&id=5c122672&scoped=true"
import script from "./Experiments.vue?vue&type=script&lang=js"
export * from "./Experiments.vue?vue&type=script&lang=js"
import style0 from "./Experiments.vue?vue&type=style&index=0&id=5c122672&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c122672",
  null
  
)

export default component.exports